import React, {useState} from 'react';
import Navbar from '../Navbar';
import {UserContext} from '../../Context/UserContext';
import Header from './Header';
import {Route} from 'react-router-dom';
import trialSettings from '../TrialUI/trialSettings';
import axiosConfig from '../../config/axios.config';
// route components
import HomePage from '../HomePage';
import Admin from '../Admin';
import VerifyEmail from '../VerifyEmail';
import TrialUI from '../TrialUI';
import TrialsLanding from '../LandingPages/TrialsLanding';
import PatientsLanding from '../LandingPages/PatientsLanding';
import FeedbackForm from '../FeedbackForm';
import AdminFeedbackForm from '../FeedbackForm/AdminFeedbackForm';
import {TrialCacheProvider} from '../TrialCache';
import {InstanceContext} from '../../InstanceContext';
// import TrialOverview from '../TrialOverview';
import OverviewContainer from '../OverviewContainer';
// import UserManagement from '../UserManagement';
import InstanceLinks from '../InstancesPage'
import axios from "axios";
const Dashboard = props => {

  // const {innerNavMenu, setInnerNavMenu} = useState(false);
  const {user} = React.useContext(UserContext);
  const [dateUpdated, setDateUpdated] = React.useState(false)
  const {contextInstance} = React.useContext(InstanceContext)
  const trialInstance = contextInstance ? contextInstance : user.instance;
  // navBar width state
  const [navSpacing, setNavSpacing] = useState(50);


  // -- build initial cache list for trials
  // must return id, path, options
  // if param options create multiple cache instances

  let trialTabs = Object.keys(trialSettings.tabs);
  let modifiedTabs = [];
  trialTabs.forEach(tabID => {
    const trialTabSettings = trialSettings.tabs[tabID];
    if (trialTabSettings.paramOptions) {
      trialTabs = trialTabs.filter(val => val !== tabID);
      Object.keys(trialTabSettings.paramOptions).forEach(paramID => {
        modifiedTabs.push(tabID +'_po_' + paramID);
      })
    }
  })
  trialTabs = trialTabs.concat(modifiedTabs);

  // construct the settings for the different tabs in the app
  const getRouteConfig = tabID => {
    const strip = tabID.includes('_po_') ? tabID.split('_po_') : false;
    const strippedID = strip ? strip[0] : tabID;
    const trialTabSettings = trialSettings.tabs[strippedID];
    const fetchParam = strip ? trialTabSettings.paramOptions[strip[1]] : 'none';
    const fetchType = trialTabSettings.fetchKey || tabID;
    const url = strippedID === 'myPatients'
    ? `${axiosConfig.apiUrl}/rt/myPatients/${trialInstance}/${fetchType}/${fetchParam}/${user.email}`
    : strippedID === 'allTrials' || strippedID === 'priorityTrials' || strippedID === 'getTrials'
    ? `${axiosConfig.apiUrl}/rt/${fetchType}/${trialInstance}/${user.email}`
    : strippedID === 'emailRecords'
    ? `${axiosConfig.apiUrl}/rt/console/get-email-records`
    : strippedID === 'studyLocation'
    ? `${axiosConfig.apiUrl}/rt/console/getFacilities/${trialInstance}/${user.email}`
    : `${axiosConfig.apiUrl}/rt/allTrials/${trialInstance}/${fetchType}/${fetchParam}/${user.email}`
    return {
      id: tabID,
      path: url,
      options: {
        url: url,
        method: tabID === 'emailRecords' ? 'post' : 'get',
        body: tabID === 'emailRecords' ? {userId: user.id} : undefined,
      }
    };
  }


  let initialCache = [];
  if (user.accountType && user.accountType === 'PI') {
    // PI fetches
    trialTabs.forEach(tabID => {
      if (tabID.includes('myPatients') || tabID.includes('getTrials') || tabID.includes('allTrials')) {
        initialCache.push(getRouteConfig(tabID));
      }
    })

  } else {
    // admin fetches
    trialTabs.forEach(tabID => initialCache.push(getRouteConfig(tabID)))
  }

    if (!dateUpdated) axios.get(`${axiosConfig.apiUrl}/rt/fetchDateUpdated/${trialInstance}`)
        .then(result => setDateUpdated(result.data))
        .catch(err =>console.log(err));


  return(
    <TrialCacheProvider initial={initialCache}>

        {/* Navigation */}
        <Navbar
          instance={props.contextInstance || user.instance}
          setInstance={props.updateContextInstance}
          sideBarToggle={props.toggleSidebar}
          isEmailAuth={props.isEmailAuth}
          toggle={props.sidebar}
          instanceDetails={{
            instance: props.instance,
            accountType: user.accountType,
            isXDAdmin: user.isXDAdmin
          }}
          history={props.history}
          setNavSpacing={setNavSpacing}
        />

        {/* Header */}
        <Header
          navSpacing={navSpacing}
          history={props.history}
          dateUpdated={dateUpdated}
          instance={props.contextInstance || user.instance}
        />

        {/* content - routes */}
        <div style={{paddingLeft: navSpacing + 'px', paddingTop: '45px', paddingRight: 20, maxWidth: '100vw'}}>
          <Route
            exact path="/trial_list/:instance/:type"
            component={(props) => <TrialUI {...props} navSpacing={navSpacing} />}
          />
          <Route exact path='/:instnace/trials_home' component={TrialsLanding} />
          <Route exact path='/:instnace/patients' component={PatientsLanding} />
          <Route
            exact path="/:instance/trials/overview/:id"
            render={props => <OverviewContainer {...props} navSpacing={navSpacing} type='trial' />}
          />
          <Route
            exact path="/:instance/user/overview/:id"
            render={props => <OverviewContainer {...props} navSpacing={navSpacing} type='registry' />}
          />
          <Route
            exact path={[
              '/:instance',
              "/:instance/feedbackForm",
              '/:instance/instances',
              "/:instance/admin_message",
              "/:instance/settings",
              "/:instance/verifyEmail/:userObjId/:token",
              "/trial_list/:instance/userManagement",
            ]}
            component={() =>
              <div style={{padding: '8px'}}>
                {/* padded routes */}
                <Route exact path='/:instance' component={HomePage} />
                <Route exact path='/:instance/instances' component={InstanceLinks} />
                <Route exact path="/:instance/feedbackForm" component={FeedbackForm}/>
                <Route exact path="/:instance/admin_message" component={AdminFeedbackForm}/>
                <Route exact path="/:instance/settings" component={Admin} />
                <Route exact path="/:instance/verifyEmail/:userObjId/:token" component={VerifyEmail} />
              </div>
            }
          />
        </div>
    </TrialCacheProvider>
  );
}

export default Dashboard;
